import CityPageTemplate from "../city-template/CityPageTemplate";
import { commerceCityConfig } from "./data";

export default function CommerceCityPage() {
  return <CityPageTemplate config={commerceCityConfig} />;
}